import { render, staticRenderFns } from "./GameLossInfo.vue?vue&type=template&id=6d0b98e5&scoped=true"
import script from "./GameLossInfo.vue?vue&type=script&lang=js"
export * from "./GameLossInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0b98e5",
  null
  
)

export default component.exports